export default "__VITE_ASSET__D0sMx8V5__"